export default __webpack_public_path__ + "static/media/mark_profile.ac989fec.png";